import { DefaultTemplate, COR, CORES_SIM_NAO, CORES_PRIORIDADE } from './types';

// ============================================================
// JURÍDICO, OPERACIONAL/PROJETOS, ATENDIMENTO e VIAGENS
// ============================================================

const contratosJuridico: DefaultTemplate = {
  id: 'tpl_contratos',
  name: 'Contratos (Jurídico)',
  descricao: 'Análise e aprovação de contratos com classificação de risco, revisão de cláusulas, assinatura e guarda com controle de vigência. O jurídico deixa de ser caixa-preta.',
  categoria: 'juridico',
  icone: '📜',
  etiquetas: [
    { nome: 'Alto risco', cor: COR.vermelho },
    { nome: 'Urgente', cor: COR.amarelo },
    { nome: 'Modelo padrão', cor: COR.verde },
  ],
  etapas: [
    {
      id: 'cj_e1', nome: 'Solicitação de Análise',
      tempoMaximoHoras: 8,
      camposVisiveisNoCard: ['cj_c1', 'cj_c3', 'cj_c6'],
      permiteMoverPara: ['cj_e2'],
      campos: [
        { id: 'cj_c1', nome: 'Título do Contrato', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'cj_c2', nome: 'Contraparte', tipo: 'texto', obrigatorio: true },
        { id: 'cj_c3', nome: 'Tipo', tipo: 'lista', obrigatorio: true, opcoes: ['Prestação de serviço', 'Fornecimento', 'Locação', 'NDA / Confidencialidade', 'Parceria', 'Trabalhista', 'Licenciamento'], coresOpcoes: { 'NDA / Confidencialidade': COR.ciano, 'Parceria': COR.roxo } },
        { id: 'cj_c4', nome: 'Área Solicitante', tipo: 'lista', obrigatorio: true, opcoes: ['Administrativo', 'Comercial', 'Operações', 'TI', 'Marketing', 'RH', 'Financeiro'] },
        { id: 'cj_c5', nome: 'Valor Envolvido', tipo: 'valor', obrigatorio: false },
        { id: 'cj_c6', nome: 'Prazo Desejado', tipo: 'data_vencimento', obrigatorio: false },
        { id: 'cj_c7', nome: 'Minuta / Documento', tipo: 'anexo', obrigatorio: true },
        { id: 'cj_c8', nome: 'Contexto da Contratação', tipo: 'texto_longo', obrigatorio: true },
      ],
    },
    {
      id: 'cj_e2', nome: 'Análise Jurídica',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['cj_c1', 'cj_c9', 'cj_c11'],
      permiteMoverPara: ['cj_e3', 'cj_e4', 'cj_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'cj_c9', nome: 'Grau de Risco', tipo: 'lista', obrigatorio: true, opcoes: ['Baixo', 'Médio', 'Alto'], coresOpcoes: { 'Baixo': COR.verde, 'Médio': COR.amarelo, 'Alto': COR.vermelho } },
        { id: 'cj_c10', nome: 'Cláusulas Críticas', tipo: 'texto_longo', obrigatorio: false },
        { id: 'cj_c11', nome: 'Parecer', tipo: 'lista', obrigatorio: true, opcoes: ['Aprovado', 'Aprovado com ajustes', 'Reprovado'], coresOpcoes: { 'Aprovado': COR.verde, 'Aprovado com ajustes': COR.amarelo, 'Reprovado': COR.vermelho } },
        { id: 'cj_c12', nome: 'Ajustes Necessários', tipo: 'texto_longo', obrigatorio: false },
        { id: 'cj_c13', nome: 'Advogado Responsável', tipo: 'texto', obrigatorio: false },
      ],
    },
    {
      id: 'cj_e3', nome: 'Ajustes com a Contraparte',
      tempoMaximoHoras: 120,
      camposVisiveisNoCard: ['cj_c1', 'cj_c2'],
      permiteMoverPara: ['cj_e2', 'cj_e4'],
      permiteCriarCards: false,
      campos: [
        { id: 'cj_c14', nome: 'Pontos em Discussão', tipo: 'texto_longo', obrigatorio: true },
        { id: 'cj_c15', nome: 'Versão Revisada', tipo: 'anexo', obrigatorio: false },
        { id: 'cj_c16', nome: 'Contraparte aceitou os ajustes?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'cj_e4', nome: 'Assinatura',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['cj_c1', 'cj_c17'],
      permiteMoverPara: ['cj_e5'],
      permiteCriarCards: false,
      campos: [
        { id: 'cj_c17', nome: 'Status', tipo: 'lista', obrigatorio: true, opcoes: ['Aguardando nossa assinatura', 'Aguardando contraparte', 'Assinado'], coresOpcoes: { 'Assinado': COR.verde, 'Aguardando contraparte': COR.amarelo } },
        { id: 'cj_c18', nome: 'Via Assinada', tipo: 'anexo', obrigatorio: false },
        { id: 'cj_c19', nome: 'Data da Assinatura', tipo: 'data', obrigatorio: false },
        { id: 'cj_c20', nome: 'Assinatura digital?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'cj_e5', nome: 'Vigente / Arquivado',
      ordenacaoCards: 'vencimento_proximo',
      camposVisiveisNoCard: ['cj_c1', 'cj_c22'],
      permiteCriarCards: false,
      campos: [
        { id: 'cj_c21', nome: 'Início da Vigência', tipo: 'data', obrigatorio: false },
        { id: 'cj_c22', nome: 'Fim da Vigência', tipo: 'data_vencimento', obrigatorio: false },
        { id: 'cj_c23', nome: 'Renovação automática?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'cj_c24', nome: 'Local de Guarda', tipo: 'texto', obrigatorio: false },
      ],
    },
    {
      id: 'cj_e6', nome: 'Reprovado',
      camposVisiveisNoCard: ['cj_c1', 'cj_c25'],
      permiteMoverPara: ['cj_e1'],
      permiteCriarCards: false,
      campos: [
        { id: 'cj_c25', nome: 'Motivo da Reprovação', tipo: 'texto_longo', obrigatorio: true },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Parecer aprovado vai direto para assinatura',
      etapaOrigemId: 'cj_e2',
      condicao: { campoId: 'cj_c11', operador: 'igual', valor: 'Aprovado' },
      etapaDestinoId: 'cj_e4',
    },
    {
      tipo: 'mover',
      nome: 'Contraparte aceitou os ajustes libera assinatura',
      etapaOrigemId: 'cj_e3',
      condicao: { campoId: 'cj_c16', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'cj_e4',
    },
    {
      tipo: 'mover',
      nome: 'Assinado vai para arquivo e controle de vigência',
      etapaOrigemId: 'cj_e4',
      condicao: { campoId: 'cj_c17', operador: 'igual', valor: 'Assinado' },
      etapaDestinoId: 'cj_e5',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Mostrar cláusulas críticas quando o risco for alto',
      etapaOrigemId: 'cj_e2',
      condicao: { campoId: 'cj_c9', operador: 'igual', valor: 'Alto' },
      camposAfetadosIds: ['cj_c10'],
    },
  ],
  cards: [
    { id: 'cj_card1', titulo: 'Contrato de fornecimento - Metalpar', etapaId: 'cj_e2', etiquetas: ['Alto risco'], valores: { cj_c1: 'Contrato de fornecimento - Metalpar', cj_c2: 'Indústria Metalpar', cj_c3: 'Fornecimento', cj_c4: 'Operações', cj_c5: 180000, cj_c9: 'Alto' } },
    { id: 'cj_card2', titulo: 'NDA - Projeto confidencial', etapaId: 'cj_e4', etiquetas: ['Modelo padrão'], valores: { cj_c1: 'NDA - Projeto confidencial', cj_c2: 'Tech Solutions Ltda', cj_c3: 'NDA / Confidencialidade', cj_c4: 'Comercial', cj_c17: 'Aguardando contraparte' } },
    { id: 'cj_card3', titulo: 'Locação de galpão logístico', etapaId: 'cj_e5', valores: { cj_c1: 'Locação de galpão logístico', cj_c2: 'Imobiliária Central', cj_c3: 'Locação', cj_c4: 'Operações', cj_c5: 22000 } },
    { id: 'cj_card4', titulo: 'Parceria comercial - Distribuidora', etapaId: 'cj_e3', valores: { cj_c1: 'Parceria comercial - Distribuidora', cj_c2: 'Distribuidora Norte', cj_c3: 'Parceria', cj_c4: 'Comercial', cj_c14: 'Exclusividade territorial e meta mínima de compra.' } },
    { id: 'cj_card5', titulo: 'Prestação de serviço - consultoria', etapaId: 'cj_e1', valores: { cj_c1: 'Prestação de serviço - consultoria', cj_c2: 'Prisma Consultoria', cj_c3: 'Prestação de serviço', cj_c4: 'Administrativo' } },
  ],
  tour: [
    '📜 Contrato analisado com prazo, risco classificado e vigência controlada.',
    '1️⃣ "Solicitação": a área anexa a minuta e explica o contexto.',
    '2️⃣ "Análise Jurídica": risco + parecer. Aprovado direto? pula para assinatura.',
    '3️⃣ "Ajustes com a Contraparte": negociação de cláusulas com versão revisada.',
    '4️⃣ "Assinatura": marcou "Assinado"? vai para o arquivo automaticamente.',
    '5️⃣ "Vigente / Arquivado": ordenado por fim de vigência — renovação nunca pega de surpresa.',
    '🚩 Risco alto abre o campo de cláusulas críticas.',
  ],
  etapasDicas: [
    { quemFaz: 'Área solicitante', objetivo: 'Enviar a minuta com contexto — jurídico sem contexto atrasa tudo.' },
    { quemFaz: 'Advogado / Jurídico', objetivo: 'Classificar risco e emitir parecer em prazo definido.', automacoes: ['Já configurado: aprovado pula direto para assinatura'] },
    { quemFaz: 'Jurídico + Área', objetivo: 'Negociar cláusulas com a contraparte e versionar o documento.' },
    { quemFaz: 'Diretoria + Contraparte', objetivo: 'Coletar assinaturas e guardar a via final.', automacoes: ['Já configurado: assinado vai para arquivo'] },
    { quemFaz: 'Jurídico', objetivo: 'Controlar vigência e avisar a área antes do vencimento.', conexoes: ['Ligue a Contratos de Fornecimento para o acompanhamento comercial'] },
    { quemFaz: 'Jurídico', objetivo: 'Registrar a recusa com fundamento.' },
  ],
};

const processosJuridicos: DefaultTemplate = {
  id: 'tpl_processos_juridicos',
  name: 'Processos Judiciais',
  descricao: 'Acompanhamento de processos com provisão contábil, prazos processuais, audiências e desfecho. Para o jurídico não perder prazo e o financeiro saber quanto provisionar.',
  categoria: 'juridico',
  icone: '⚖️',
  etiquetas: [
    { nome: 'Prazo fatal', cor: COR.vermelho },
    { nome: 'Trabalhista', cor: COR.amarelo },
    { nome: 'Acordo possível', cor: COR.verde },
  ],
  etapas: [
    {
      id: 'pj_e1', nome: 'Novo Processo',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['pj_c1', 'pj_c3', 'pj_c6'],
      permiteMoverPara: ['pj_e2'],
      campos: [
        { id: 'pj_c1', nome: 'Nº do Processo', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'pj_c2', nome: 'Parte Contrária', tipo: 'texto', obrigatorio: true },
        { id: 'pj_c3', nome: 'Tipo', tipo: 'lista', obrigatorio: true, opcoes: ['Trabalhista', 'Cível', 'Tributário', 'Consumidor', 'Administrativo'], coresOpcoes: { 'Trabalhista': COR.amarelo, 'Tributário': COR.roxo } },
        { id: 'pj_c4', nome: 'Polo', tipo: 'lista', obrigatorio: true, opcoes: ['Autor (nós processamos)', 'Réu (nos processaram)'], coresOpcoes: { 'Réu (nos processaram)': COR.vermelho, 'Autor (nós processamos)': COR.azul } },
        { id: 'pj_c5', nome: 'Comarca / Vara', tipo: 'texto', obrigatorio: false },
        { id: 'pj_c6', nome: 'Valor da Causa', tipo: 'valor', obrigatorio: false },
        { id: 'pj_c7', nome: 'Advogado Responsável', tipo: 'texto', obrigatorio: false },
        { id: 'pj_c8', nome: 'Resumo dos Fatos', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'pj_e2', nome: 'Análise e Estratégia',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['pj_c1', 'pj_c9', 'pj_c10'],
      permiteMoverPara: ['pj_e3'],
      permiteCriarCards: false,
      campos: [
        { id: 'pj_c9', nome: 'Prognóstico', tipo: 'lista', obrigatorio: true, opcoes: ['Provável êxito', 'Possível', 'Remoto'], coresOpcoes: { 'Provável êxito': COR.verde, 'Possível': COR.amarelo, 'Remoto': COR.vermelho } },
        { id: 'pj_c10', nome: 'Provisão Contábil', tipo: 'valor', obrigatorio: false },
        { id: 'pj_c11', nome: 'Estratégia Definida', tipo: 'texto_longo', obrigatorio: true },
        { id: 'pj_c12', nome: 'Vale tentar acordo?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'pj_e3', nome: 'Em Andamento',
      camposVisiveisNoCard: ['pj_c1', 'pj_c13', 'pj_c14'],
      permiteMoverPara: ['pj_e4', 'pj_e5'],
      permiteCriarCards: false,
      campos: [
        { id: 'pj_c13', nome: 'Fase Atual', tipo: 'lista', obrigatorio: false, opcoes: ['Petição inicial', 'Contestação', 'Instrução', 'Perícia', 'Sentença', 'Recurso', 'Execução'] },
        { id: 'pj_c14', nome: 'Próximo Prazo', tipo: 'data_vencimento', obrigatorio: false },
        { id: 'pj_c15', nome: 'Últimas Movimentações', tipo: 'texto_longo', obrigatorio: false },
        { id: 'pj_c16', nome: 'Documentos do Processo', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'pj_e4', nome: 'Audiência / Perícia',
      tempoMaximoHoras: 48,
      ordenacaoCards: 'vencimento_proximo',
      camposVisiveisNoCard: ['pj_c1', 'pj_c17'],
      permiteMoverPara: ['pj_e3', 'pj_e5'],
      permiteCriarCards: false,
      campos: [
        { id: 'pj_c17', nome: 'Data da Audiência', tipo: 'data_vencimento', obrigatorio: true },
        { id: 'pj_c18', nome: 'Tipo', tipo: 'lista', obrigatorio: false, opcoes: ['Conciliação', 'Instrução', 'Julgamento', 'Perícia técnica'] },
        { id: 'pj_c19', nome: 'Preposto / Testemunhas', tipo: 'texto_longo', obrigatorio: false },
        { id: 'pj_c20', nome: 'Resultado', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'pj_e5', nome: 'Encerrado',
      camposVisiveisNoCard: ['pj_c1', 'pj_c21', 'pj_c22'],
      permiteCriarCards: false,
      campos: [
        { id: 'pj_c21', nome: 'Desfecho', tipo: 'lista', obrigatorio: true, opcoes: ['Ganho', 'Perdido', 'Acordo', 'Extinto', 'Arquivado'], coresOpcoes: { 'Ganho': COR.verde, 'Perdido': COR.vermelho, 'Acordo': COR.amarelo } },
        { id: 'pj_c22', nome: 'Valor Final Pago/Recebido', tipo: 'valor', obrigatorio: false },
        { id: 'pj_c23', nome: 'Data do Encerramento', tipo: 'data', obrigatorio: false },
        { id: 'pj_c24', nome: 'Lição Aprendida', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Estratégia definida coloca o processo em andamento',
      etapaOrigemId: 'pj_e2',
      condicao: { campoId: 'pj_c11', operador: 'preenchido' },
      etapaDestinoId: 'pj_e3',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Mostrar provisão quando o prognóstico for ruim',
      etapaOrigemId: 'pj_e2',
      condicao: { campoId: 'pj_c9', operador: 'igual', valor: 'Remoto' },
      camposAfetadosIds: ['pj_c10'],
    },
  ],
  cards: [
    { id: 'pj_card1', titulo: '0001234-56.2026.5.02.0011', etapaId: 'pj_e4', etiquetas: ['Trabalhista', 'Prazo fatal'], valores: { pj_c1: '0001234-56.2026.5.02.0011', pj_c2: 'Ex-colaborador', pj_c3: 'Trabalhista', pj_c4: 'Réu (nos processaram)', pj_c6: 45000, pj_c9: 'Possível' } },
    { id: 'pj_card2', titulo: '1005678-90.2026.8.26.0100', etapaId: 'pj_e3', valores: { pj_c1: '1005678-90.2026.8.26.0100', pj_c2: 'Distribuidora Norte', pj_c3: 'Cível', pj_c4: 'Autor (nós processamos)', pj_c6: 12300, pj_c13: 'Instrução' } },
    { id: 'pj_card3', titulo: '0009876-54.2025.4.03.6100', etapaId: 'pj_e5', valores: { pj_c1: '0009876-54.2025.4.03.6100', pj_c2: 'União Federal', pj_c3: 'Tributário', pj_c4: 'Autor (nós processamos)', pj_c21: 'Ganho', pj_c22: 87000 } },
    { id: 'pj_card4', titulo: '0004321-11.2026.5.02.0033', etapaId: 'pj_e2', etiquetas: ['Trabalhista', 'Acordo possível'], valores: { pj_c1: '0004321-11.2026.5.02.0033', pj_c2: 'Ex-colaborador', pj_c3: 'Trabalhista', pj_c4: 'Réu (nos processaram)', pj_c6: 28000, pj_c9: 'Remoto', pj_c10: 22000, pj_c12: 'Sim' } },
  ],
  tour: [
    '⚖️ Processos com prazo visível e provisão calculada.',
    '1️⃣ "Novo Processo": número, polo, valor da causa e advogado.',
    '2️⃣ "Análise e Estratégia": prognóstico e provisão contábil (o financeiro agradece).',
    '3️⃣ "Em Andamento": fase processual e próximo prazo com alerta.',
    '4️⃣ "Audiência / Perícia": ordenada por data — o mais próximo no topo.',
    '5️⃣ "Encerrado": desfecho e valor final, com lição aprendida.',
    '💰 Prognóstico remoto abre o campo de provisão — número certo no balanço.',
  ],
  etapasDicas: [
    { quemFaz: 'Jurídico', objetivo: 'Cadastrar o processo assim que a citação chegar.' },
    { quemFaz: 'Advogado responsável', objetivo: 'Definir estratégia e provisionar o risco.', automacoes: ['Já configurado: provisão aparece quando o prognóstico é remoto'] },
    { quemFaz: 'Advogado', objetivo: 'Acompanhar movimentações e nunca perder prazo.', conexoes: ['Ligue a Contas a Pagar quando houver depósito judicial'] },
    { quemFaz: 'Advogado + Preposto', objetivo: 'Preparar audiência com preposto e testemunhas definidos.' },
    { quemFaz: 'Jurídico + Controladoria', objetivo: 'Registrar desfecho e baixar a provisão.' },
  ],
};

const gestaoProjetos: DefaultTemplate = {
  id: 'tpl_gestao_projetos',
  name: 'Gestão de Projetos',
  descricao: 'Projetos com escopo aprovado, planejamento, execução acompanhada por progresso, homologação do cliente e encerramento com lições aprendidas. Inclui coluna de riscos e impedimentos.',
  categoria: 'operacional',
  icone: '📊',
  etiquetas: [
    { nome: 'Atrasado', cor: COR.vermelho },
    { nome: 'Cliente externo', cor: COR.roxo },
    { nome: 'Estratégico', cor: COR.azul },
  ],
  etapas: [
    {
      id: 'gp_e1', nome: 'Ideia / Backlog',
      camposVisiveisNoCard: ['gp_c1', 'gp_c4'],
      permiteMoverPara: ['gp_e2'],
      campos: [
        { id: 'gp_c1', nome: 'Nome do Projeto', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'gp_c2', nome: 'Objetivo', tipo: 'texto_longo', obrigatorio: true },
        { id: 'gp_c3', nome: 'Patrocinador', tipo: 'texto', obrigatorio: false },
        { id: 'gp_c4', nome: 'Prioridade', tipo: 'lista', obrigatorio: true, opcoes: ['Baixa', 'Média', 'Alta', 'Urgente'], coresOpcoes: CORES_PRIORIDADE },
        { id: 'gp_c5', nome: 'Benefício Esperado', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'gp_e2', nome: 'Aprovação de Escopo',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['gp_c1', 'gp_c7', 'gp_c9'],
      permiteMoverPara: ['gp_e3', 'gp_e7'],
      permiteCriarCards: false,
      campos: [
        { id: 'gp_c6', nome: 'Escopo Detalhado', tipo: 'texto_longo', obrigatorio: true },
        { id: 'gp_c7', nome: 'Orçamento Estimado', tipo: 'valor', obrigatorio: false },
        { id: 'gp_c8', nome: 'Prazo Estimado', tipo: 'data_vencimento', obrigatorio: false },
        { id: 'gp_c9', nome: 'Aprovado?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'gp_c10', nome: 'Restrições', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'gp_e3', nome: 'Planejamento',
      tempoMaximoHoras: 120,
      camposVisiveisNoCard: ['gp_c1', 'gp_c12'],
      permiteMoverPara: ['gp_e4'],
      permiteCriarCards: false,
      campos: [
        { id: 'gp_c11', nome: 'Gerente do Projeto', tipo: 'texto', obrigatorio: true },
        { id: 'gp_c12', nome: 'Data de Início', tipo: 'data', obrigatorio: false },
        { id: 'gp_c13', nome: 'Equipe Envolvida', tipo: 'texto_longo', obrigatorio: false },
        { id: 'gp_c14', nome: 'Marcos / Entregas', tipo: 'texto_longo', obrigatorio: true },
        { id: 'gp_c15', nome: 'Cronograma', tipo: 'anexo', obrigatorio: false },
        { id: 'gp_c16', nome: 'Planejamento concluído?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'gp_e4', nome: 'Em Execução',
      camposVisiveisNoCard: ['gp_c1', 'gp_c17', 'gp_c8'],
      permiteMoverPara: ['gp_e5', 'gp_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'gp_c17', nome: 'Progresso', tipo: 'progresso', obrigatorio: false },
        { id: 'gp_c18', nome: 'Status Report', tipo: 'texto_longo', obrigatorio: false },
        { id: 'gp_c19', nome: 'Custo Realizado', tipo: 'valor', obrigatorio: false },
        { id: 'gp_c20', nome: 'Há impedimento?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'gp_e5', nome: 'Homologação',
      tempoMaximoHoras: 120,
      camposVisiveisNoCard: ['gp_c1', 'gp_c22'],
      permiteMoverPara: ['gp_e8', 'gp_e4'],
      permiteCriarCards: false,
      campos: [
        { id: 'gp_c21', nome: 'Entregáveis', tipo: 'anexo', obrigatorio: false },
        { id: 'gp_c22', nome: 'Aceite do Patrocinador?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'gp_c23', nome: 'Ajustes Solicitados', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'gp_e6', nome: 'Riscos / Impedimentos',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['gp_c1', 'gp_c24'],
      permiteMoverPara: ['gp_e4'],
      permiteCriarCards: false,
      campos: [
        { id: 'gp_c24', nome: 'Descrição do Risco', tipo: 'texto_longo', obrigatorio: true },
        { id: 'gp_c25', nome: 'Impacto', tipo: 'lista', obrigatorio: false, opcoes: ['Baixo', 'Médio', 'Alto'], coresOpcoes: { 'Baixo': COR.verde, 'Médio': COR.amarelo, 'Alto': COR.vermelho } },
        { id: 'gp_c26', nome: 'Plano de Mitigação', tipo: 'texto_longo', obrigatorio: false },
        { id: 'gp_c27', nome: 'Resolvido?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'gp_e7', nome: 'Não Aprovado',
      camposVisiveisNoCard: ['gp_c1', 'gp_c28'],
      permiteMoverPara: ['gp_e1'],
      permiteCriarCards: false,
      campos: [
        { id: 'gp_c28', nome: 'Motivo', tipo: 'texto_longo', obrigatorio: true },
      ],
    },
    {
      id: 'gp_e8', nome: 'Encerrado',
      camposVisiveisNoCard: ['gp_c1', 'gp_c19'],
      permiteCriarCards: false,
      campos: [
        { id: 'gp_c29', nome: 'Data de Encerramento', tipo: 'data', obrigatorio: false },
        { id: 'gp_c30', nome: 'Entregou no prazo?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'gp_c31', nome: 'Lições Aprendidas', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Escopo aprovado vai para planejamento',
      etapaOrigemId: 'gp_e2',
      condicao: { campoId: 'gp_c9', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'gp_e3',
      etapaDestinoSenaoId: 'gp_e7',
    },
    {
      tipo: 'mover',
      nome: 'Planejamento concluído inicia a execução',
      etapaOrigemId: 'gp_e3',
      condicao: { campoId: 'gp_c16', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'gp_e4',
    },
    {
      tipo: 'mover',
      nome: 'Impedimento sinalizado abre a coluna de riscos',
      etapaOrigemId: 'gp_e4',
      condicao: { campoId: 'gp_c20', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'gp_e6',
    },
    {
      tipo: 'mover',
      nome: 'Aceite do patrocinador encerra o projeto',
      etapaOrigemId: 'gp_e5',
      condicao: { campoId: 'gp_c22', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'gp_e8',
      etapaDestinoSenaoId: 'gp_e4',
    },
    {
      tipo: 'mover',
      nome: 'Risco resolvido devolve o projeto à execução',
      etapaOrigemId: 'gp_e6',
      condicao: { campoId: 'gp_c27', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'gp_e4',
    },
  ],
  cards: [
    { id: 'gp_card1', titulo: 'Implantação do novo ERP', etapaId: 'gp_e4', etiquetas: ['Estratégico'], valores: { gp_c1: 'Implantação do novo ERP', gp_c4: 'Alta', gp_c7: 240000, gp_c17: 45, gp_c19: 98000 } },
    { id: 'gp_card2', titulo: 'Expansão do CD regional', etapaId: 'gp_e3', valores: { gp_c1: 'Expansão do CD regional', gp_c4: 'Alta', gp_c7: 520000 } },
    { id: 'gp_card3', titulo: 'Portal do cliente', etapaId: 'gp_e5', etiquetas: ['Cliente externo'], valores: { gp_c1: 'Portal do cliente', gp_c4: 'Média', gp_c7: 85000, gp_c17: 95 } },
    { id: 'gp_card4', titulo: 'Certificação ISO 9001', etapaId: 'gp_e6', etiquetas: ['Atrasado'], valores: { gp_c1: 'Certificação ISO 9001', gp_c4: 'Média', gp_c24: 'Consultoria contratada atrasou a entrega dos procedimentos.', gp_c25: 'Alto' } },
    { id: 'gp_card5', titulo: 'Automação da linha 3', etapaId: 'gp_e2', valores: { gp_c1: 'Automação da linha 3', gp_c4: 'Alta', gp_c7: 180000 } },
    { id: 'gp_card6', titulo: 'Reforma da recepção', etapaId: 'gp_e8', valores: { gp_c1: 'Reforma da recepção', gp_c4: 'Baixa', gp_c19: 34000, gp_c30: 'Sim' } },
    { id: 'gp_card7', titulo: 'App de vendas mobile', etapaId: 'gp_e1', valores: { gp_c1: 'App de vendas mobile', gp_c4: 'Média' } },
  ],
  tour: [
    '📊 Projeto do rascunho ao encerramento com riscos visíveis.',
    '1️⃣ "Ideia / Backlog": tudo que alguém propôs, priorizado.',
    '2️⃣ "Aprovação de Escopo": orçamento e prazo. Reprovado vai para "Não Aprovado".',
    '3️⃣ "Planejamento": gerente, equipe e marcos. Concluiu? a execução começa sozinha.',
    '4️⃣ "Em Execução": barra de progresso e custo realizado x orçado.',
    '🚧 Marcou "há impedimento"? o card sai para "Riscos / Impedimentos" — visível para todos.',
    '5️⃣ "Homologação": o patrocinador aceita ou devolve com ajustes.',
    '📚 "Encerrado" com lições aprendidas — o próximo projeto começa melhor.',
  ],
  etapasDicas: [
    { quemFaz: 'Qualquer área', objetivo: 'Registrar a ideia sem perder — backlog é memória da empresa.' },
    { quemFaz: 'Diretoria / PMO', objetivo: 'Aprovar escopo, prazo e orçamento antes de gastar recurso.', automacoes: ['Já configurado: aprovado vai para planejamento'] },
    { quemFaz: 'Gerente do Projeto', objetivo: 'Definir marcos e equipe antes do primeiro dia de execução.' },
    { quemFaz: 'Equipe do projeto', objetivo: 'Executar com progresso e custo visíveis — status report sem reunião.', automacoes: ['Já configurado: impedimento move para a coluna de riscos'] },
    { quemFaz: 'Patrocinador', objetivo: 'Aceitar formalmente os entregáveis.', automacoes: ['Já configurado: aceite encerra, recusa devolve para execução'] },
    { quemFaz: 'Gerente do Projeto', objetivo: 'Tratar risco com plano de mitigação e prazo.', automacoes: ['Já configurado: risco resolvido devolve o projeto'] },
    { quemFaz: 'PMO', objetivo: 'Guardar o motivo da reprovação para reavaliação futura.' },
    { quemFaz: 'PMO', objetivo: 'Fechar com lições aprendidas e comparar orçado x realizado.' },
  ],
};

const atendimento: DefaultTemplate = {
  id: 'tpl_atendimento',
  name: 'Atendimento ao Cliente (SAC)',
  descricao: 'Canal único para reclamação, dúvida, elogio e solicitação, com classificação, SLA por criticidade, tratativa, validação do cliente e pesquisa de satisfação no fechamento.',
  categoria: 'atendimento',
  icone: '🎧',
  etiquetas: [
    { nome: 'Reclamação grave', cor: COR.vermelho },
    { nome: 'Reincidente', cor: COR.amarelo },
    { nome: 'Elogio', cor: COR.verde },
    { nome: 'Órgão externo', cor: COR.roxo },
  ],
  etapas: [
    {
      id: 'at_e1', nome: 'Novo Atendimento',
      tempoMaximoHoras: 2,
      camposVisiveisNoCard: ['at_c1', 'at_c4', 'at_c6'],
      permiteMoverPara: ['at_e2'],
      campos: [
        { id: 'at_c1', nome: 'Cliente', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'at_c2', nome: 'Telefone', tipo: 'telefone', obrigatorio: false },
        { id: 'at_c3', nome: 'E-mail', tipo: 'texto', obrigatorio: false },
        { id: 'at_c4', nome: 'Tipo', tipo: 'lista', obrigatorio: true, opcoes: ['Reclamação', 'Dúvida', 'Solicitação', 'Elogio', 'Sugestão', 'Cancelamento'], coresOpcoes: { 'Reclamação': COR.vermelho, 'Elogio': COR.verde, 'Cancelamento': COR.roxo, 'Dúvida': COR.azul } },
        { id: 'at_c5', nome: 'Canal', tipo: 'lista', obrigatorio: true, opcoes: ['Telefone', 'WhatsApp', 'E-mail', 'Site / Chat', 'Presencial', 'Reclame Aqui', 'Procon'], coresOpcoes: { 'Reclame Aqui': COR.roxo, 'Procon': COR.vermelho } },
        { id: 'at_c6', nome: 'Criticidade', tipo: 'lista', obrigatorio: true, opcoes: ['Baixa', 'Média', 'Alta', 'Urgente'], coresOpcoes: CORES_PRIORIDADE },
        { id: 'at_c7', nome: 'Relato do Cliente', tipo: 'texto_longo', obrigatorio: true },
        { id: 'at_c8', nome: 'Anexos', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'at_e2', nome: 'Em Análise',
      tempoMaximoHoras: 8,
      camposVisiveisNoCard: ['at_c1', 'at_c6', 'at_c10'],
      permiteMoverPara: ['at_e3', 'at_e4'],
      permiteCriarCards: false,
      campos: [
        { id: 'at_c9', nome: 'Atendente', tipo: 'texto', obrigatorio: false },
        { id: 'at_c10', nome: 'Área Responsável', tipo: 'lista', obrigatorio: true, opcoes: ['Comercial', 'Operações', 'Financeiro', 'TI', 'Logística', 'Qualidade'] },
        { id: 'at_c11', nome: 'Causa Identificada', tipo: 'texto_longo', obrigatorio: false },
        { id: 'at_c12', nome: 'É reincidente?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'at_c13', nome: 'Procede?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'at_e3', nome: 'Em Tratativa',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['at_c1', 'at_c14'],
      permiteMoverPara: ['at_e4'],
      permiteCriarCards: false,
      campos: [
        { id: 'at_c14', nome: 'Ação Tomada', tipo: 'texto_longo', obrigatorio: true },
        { id: 'at_c15', nome: 'Tipo de Solução', tipo: 'lista', obrigatorio: false, opcoes: ['Troca', 'Reembolso', 'Reparo', 'Reenvio', 'Desconto / crédito', 'Orientação', 'Sem custo para o cliente'] },
        { id: 'at_c16', nome: 'Custo da Solução', tipo: 'valor', obrigatorio: false },
        { id: 'at_c17', nome: 'Prazo Prometido ao Cliente', tipo: 'data_vencimento', obrigatorio: false },
      ],
    },
    {
      id: 'at_e4', nome: 'Aguardando Cliente',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['at_c1', 'at_c19'],
      permiteMoverPara: ['at_e3', 'at_e5'],
      permiteCriarCards: false,
      campos: [
        { id: 'at_c18', nome: 'Resposta Enviada', tipo: 'texto_longo', obrigatorio: false },
        { id: 'at_c19', nome: 'Cliente ficou satisfeito?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'at_e5', nome: 'Encerrado',
      camposVisiveisNoCard: ['at_c1', 'at_c4', 'at_c20'],
      permiteCriarCards: false,
      campos: [
        { id: 'at_c20', nome: 'Satisfação (0-10)', tipo: 'numero', obrigatorio: false, valorMinimo: 0, valorMaximo: 10 },
        { id: 'at_c21', nome: 'Gerou ação corretiva?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'at_c22', nome: 'Observações Finais', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Reclamação procedente vai para tratativa',
      etapaOrigemId: 'at_e2',
      condicao: { campoId: 'at_c13', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'at_e3',
      etapaDestinoSenaoId: 'at_e4',
    },
    {
      tipo: 'mover',
      nome: 'Cliente satisfeito encerra o atendimento',
      etapaOrigemId: 'at_e4',
      condicao: { campoId: 'at_c19', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'at_e5',
      etapaDestinoSenaoId: 'at_e3',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Mostrar causa quando for reincidente',
      etapaOrigemId: 'at_e2',
      condicao: { campoId: 'at_c12', operador: 'igual', valor: 'Sim' },
      camposAfetadosIds: ['at_c11'],
    },
  ],
  cards: [
    { id: 'at_card1', titulo: 'Rede Farmácia Vida', etapaId: 'at_e3', etiquetas: ['Reclamação grave'], valores: { at_c1: 'Rede Farmácia Vida', at_c4: 'Reclamação', at_c5: 'Telefone', at_c6: 'Urgente', at_c10: 'Logística', at_c13: 'Sim', at_c15: 'Reenvio' } },
    { id: 'at_card2', titulo: 'Comércio Silva ME', etapaId: 'at_e2', valores: { at_c1: 'Comércio Silva ME', at_c4: 'Dúvida', at_c5: 'WhatsApp', at_c6: 'Baixa', at_c10: 'Comercial' } },
    { id: 'at_card3', titulo: 'Grupo Andrade', etapaId: 'at_e5', etiquetas: ['Elogio'], valores: { at_c1: 'Grupo Andrade', at_c4: 'Elogio', at_c5: 'E-mail', at_c6: 'Baixa', at_c20: 10 } },
    { id: 'at_card4', titulo: 'Distribuidora Norte', etapaId: 'at_e2', etiquetas: ['Reincidente', 'Órgão externo'], valores: { at_c1: 'Distribuidora Norte', at_c4: 'Reclamação', at_c5: 'Reclame Aqui', at_c6: 'Alta', at_c10: 'Qualidade', at_c12: 'Sim' } },
    { id: 'at_card5', titulo: 'Transportes Rocha', etapaId: 'at_e4', valores: { at_c1: 'Transportes Rocha', at_c4: 'Solicitação', at_c5: 'Site / Chat', at_c6: 'Média', at_c10: 'Financeiro' } },
    { id: 'at_card6', titulo: 'Indústria Metalpar', etapaId: 'at_e1', valores: { at_c1: 'Indústria Metalpar', at_c4: 'Sugestão', at_c5: 'E-mail', at_c6: 'Baixa' } },
  ],
  tour: [
    '🎧 SAC com SLA de 2h para primeira resposta.',
    '1️⃣ "Novo Atendimento": tipo, canal e criticidade. Procon e Reclame Aqui já vêm destacados.',
    '2️⃣ "Em Análise": direciona para a área e decide se procede.',
    '3️⃣ "Em Tratativa": ação tomada, tipo de solução e custo — dá para medir quanto o problema custa.',
    '4️⃣ "Aguardando Cliente": satisfeito? encerra. Não? volta para tratativa automaticamente.',
    '5️⃣ "Encerrado" com nota de satisfação e sinalização de ação corretiva.',
    '🔁 Marcou "reincidente"? o campo de causa aparece — é o que alimenta a Qualidade.',
  ],
  etapasDicas: [
    { quemFaz: 'Atendente', objetivo: 'Registrar o relato do cliente na íntegra, sem interpretar.' },
    { quemFaz: 'Supervisor de atendimento', objetivo: 'Classificar, direcionar e decidir se a reclamação procede.', automacoes: ['Já configurado: procedente vai para tratativa'] },
    { quemFaz: 'Área responsável', objetivo: 'Resolver e registrar o custo da solução.', conexoes: ['Ligue a Não Conformidades quando a causa for falha de processo'] },
    { quemFaz: 'Atendente', objetivo: 'Confirmar com o cliente antes de encerrar.', automacoes: ['Já configurado: insatisfeito volta para tratativa'] },
    { quemFaz: 'Supervisor', objetivo: 'Medir satisfação e sinalizar o que virou ação corretiva.' },
  ],
};

const viagens: DefaultTemplate = {
  id: 'tpl_viagens',
  name: 'Viagens Corporativas',
  descricao: 'Solicitação, aprovação, reserva, adiantamento e prestação de contas de viagens. Controla o gasto antes de acontecer e fecha com comprovantes conferidos.',
  categoria: 'viagens',
  icone: '✈️',
  etiquetas: [
    { nome: 'Internacional', cor: COR.roxo },
    { nome: 'Cliente', cor: COR.azul },
    { nome: 'Pendência de prestação', cor: COR.vermelho },
  ],
  etapas: [
    {
      id: 'vg_e1', nome: 'Solicitação',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['vg_c1', 'vg_c3', 'vg_c5'],
      permiteMoverPara: ['vg_e2'],
      campos: [
        { id: 'vg_c1', nome: 'Viajante', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'vg_c2', nome: 'Departamento', tipo: 'lista', obrigatorio: true, opcoes: ['Administrativo', 'Comercial', 'Operações', 'TI', 'Marketing', 'RH', 'Financeiro'] },
        { id: 'vg_c3', nome: 'Destino', tipo: 'texto', obrigatorio: true },
        { id: 'vg_c4', nome: 'Motivo da Viagem', tipo: 'lista', obrigatorio: true, opcoes: ['Visita a cliente', 'Feira / Evento', 'Treinamento', 'Reunião interna', 'Manutenção / Suporte', 'Auditoria'], coresOpcoes: { 'Visita a cliente': COR.azul, 'Feira / Evento': COR.roxo } },
        { id: 'vg_c5', nome: 'Data de Ida', tipo: 'data', obrigatorio: true },
        { id: 'vg_c6', nome: 'Data de Volta', tipo: 'data', obrigatorio: true },
        { id: 'vg_c7', nome: 'Justificativa', tipo: 'texto_longo', obrigatorio: true },
        { id: 'vg_c8', nome: 'Custo Estimado', tipo: 'valor', obrigatorio: false },
        { id: 'vg_c9', nome: 'Necessidades', tipo: 'checkbox_multi', obrigatorio: false, opcoes: ['Passagem aérea', 'Hospedagem', 'Carro / Locação', 'Adiantamento', 'Seguro viagem'] },
        { id: 'vg_c10', nome: 'Viagem internacional?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'vg_e2', nome: 'Aprovação',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['vg_c1', 'vg_c8', 'vg_c11'],
      permiteMoverPara: ['vg_e3', 'vg_e7'],
      permiteCriarCards: false,
      campos: [
        { id: 'vg_c11', nome: 'Aprovado?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'vg_c12', nome: 'Verba Autorizada', tipo: 'valor', obrigatorio: false },
        { id: 'vg_c13', nome: 'Observação do Aprovador', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'vg_e3', nome: 'Reservas',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['vg_c1', 'vg_c3', 'vg_c5'],
      permiteMoverPara: ['vg_e4'],
      permiteCriarCards: false,
      campos: [
        { id: 'vg_c14', nome: 'Itens Reservados', tipo: 'checkbox_multi', obrigatorio: true, opcoes: ['Passagem', 'Hotel', 'Carro', 'Transfer'] },
        { id: 'vg_c15', nome: 'Bilhetes / Vouchers', tipo: 'anexo', obrigatorio: false },
        { id: 'vg_c16', nome: 'Custo Real das Reservas', tipo: 'valor', obrigatorio: false },
        { id: 'vg_c17', nome: 'Reservas concluídas?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'vg_e4', nome: 'Adiantamento',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['vg_c1', 'vg_c18'],
      permiteMoverPara: ['vg_e5'],
      permiteCriarCards: false,
      campos: [
        { id: 'vg_c18', nome: 'Valor Adiantado', tipo: 'valor', obrigatorio: false },
        { id: 'vg_c19', nome: 'Data do Adiantamento', tipo: 'data', obrigatorio: false },
        { id: 'vg_c20', nome: 'Forma', tipo: 'lista', obrigatorio: false, opcoes: ['PIX', 'Transferência', 'Cartão corporativo', 'Sem adiantamento'] },
      ],
    },
    {
      id: 'vg_e5', nome: 'Em Viagem',
      camposVisiveisNoCard: ['vg_c1', 'vg_c3', 'vg_c6'],
      permiteMoverPara: ['vg_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'vg_c21', nome: 'Ocorrências durante a viagem', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'vg_e6', nome: 'Prestação de Contas',
      tempoMaximoHoras: 120,
      ordenacaoCards: 'mais_antigo',
      camposVisiveisNoCard: ['vg_c1', 'vg_c23', 'vg_c25'],
      permiteMoverPara: ['vg_e8'],
      permiteCriarCards: false,
      campos: [
        { id: 'vg_c22', nome: 'Comprovantes', tipo: 'anexo', obrigatorio: true },
        { id: 'vg_c23', nome: 'Total Gasto', tipo: 'valor', obrigatorio: true },
        { id: 'vg_c24', nome: 'Detalhamento das Despesas', tipo: 'texto_longo', obrigatorio: false },
        { id: 'vg_c25', nome: 'Saldo (devolver / receber)', tipo: 'valor', obrigatorio: false },
        { id: 'vg_c26', nome: 'Conferido pelo financeiro?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'vg_c27', nome: 'Relatório da Viagem', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'vg_e7', nome: 'Não Aprovada',
      camposVisiveisNoCard: ['vg_c1', 'vg_c28'],
      permiteMoverPara: ['vg_e1'],
      permiteCriarCards: false,
      campos: [
        { id: 'vg_c28', nome: 'Motivo', tipo: 'texto_longo', obrigatorio: true },
      ],
    },
    {
      id: 'vg_e8', nome: 'Concluída',
      camposVisiveisNoCard: ['vg_c1', 'vg_c23'],
      permiteCriarCards: false,
      campos: [
        { id: 'vg_c29', nome: 'Data do Encerramento', tipo: 'data', obrigatorio: false },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Viagem aprovada libera as reservas',
      etapaOrigemId: 'vg_e2',
      condicao: { campoId: 'vg_c11', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'vg_e3',
      etapaDestinoSenaoId: 'vg_e7',
    },
    {
      tipo: 'mover',
      nome: 'Reservas concluídas seguem para adiantamento',
      etapaOrigemId: 'vg_e3',
      condicao: { campoId: 'vg_c17', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'vg_e4',
    },
    {
      tipo: 'mover',
      nome: 'Prestação conferida encerra a viagem',
      etapaOrigemId: 'vg_e6',
      condicao: { campoId: 'vg_c26', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'vg_e8',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Mostrar verba autorizada quando aprovar',
      etapaOrigemId: 'vg_e2',
      condicao: { campoId: 'vg_c11', operador: 'igual', valor: 'Sim' },
      camposAfetadosIds: ['vg_c12'],
    },
  ],
  cards: [
    { id: 'vg_card1', titulo: 'Marina Costa', etapaId: 'vg_e3', etiquetas: ['Cliente'], valores: { vg_c1: 'Marina Costa', vg_c2: 'Comercial', vg_c3: 'São Paulo - SP', vg_c4: 'Visita a cliente', vg_c8: 2400, vg_c12: 2400 } },
    { id: 'vg_card2', titulo: 'Rafael Souza', etapaId: 'vg_e6', etiquetas: ['Pendência de prestação'], valores: { vg_c1: 'Rafael Souza', vg_c2: 'Operações', vg_c3: 'Campinas - SP', vg_c4: 'Manutenção / Suporte', vg_c18: 800, vg_c23: 745 } },
    { id: 'vg_card3', titulo: 'Juliana Reis', etapaId: 'vg_e2', valores: { vg_c1: 'Juliana Reis', vg_c2: 'RH', vg_c3: 'Belo Horizonte - MG', vg_c4: 'Treinamento', vg_c8: 3100 } },
    { id: 'vg_card4', titulo: 'Carlos Menezes', etapaId: 'vg_e8', valores: { vg_c1: 'Carlos Menezes', vg_c2: 'Comercial', vg_c3: 'Curitiba - PR', vg_c4: 'Feira / Evento', vg_c23: 4280 } },
    { id: 'vg_card5', titulo: 'Pedro Lima', etapaId: 'vg_e5', etiquetas: ['Internacional'], valores: { vg_c1: 'Pedro Lima', vg_c2: 'TI', vg_c3: 'Lisboa - Portugal', vg_c4: 'Feira / Evento', vg_c10: 'Sim', vg_c8: 18000 } },
    { id: 'vg_card6', titulo: 'Fernanda Dias', etapaId: 'vg_e7', valores: { vg_c1: 'Fernanda Dias', vg_c2: 'Financeiro', vg_c3: 'Salvador - BA', vg_c4: 'Reunião interna', vg_c28: 'Reunião pode ser feita por videoconferência.' } },
  ],
  tour: [
    '✈️ Viagem controlada do pedido à prestação de contas.',
    '1️⃣ "Solicitação": destino, datas, motivo e o que precisa (passagem, hotel, adiantamento).',
    '2️⃣ "Aprovação": aprovou libera reservas e mostra a verba autorizada.',
    '3️⃣ "Reservas": checklist do que já foi comprado, com vouchers anexados.',
    '4️⃣ "Adiantamento": valor liberado antes da viagem.',
    '5️⃣ "Em Viagem" → "Prestação de Contas" com comprovantes obrigatórios.',
    '💵 O campo "Saldo" mostra se o viajante devolve ou recebe a diferença.',
    '📋 A coluna de prestação vem ordenada pelos mais antigos — cobre quem está devendo.',
  ],
  etapasDicas: [
    { quemFaz: 'Colaborador', objetivo: 'Pedir a viagem com antecedência — passagem de última hora custa o dobro.' },
    { quemFaz: 'Gestor', objetivo: 'Autorizar com verba definida.', automacoes: ['Já configurado: aprovado libera reservas'] },
    { quemFaz: 'Administrativo / Agência', objetivo: 'Comprar e anexar os vouchers.', conexoes: ['Ligue a Contas a Pagar para o pagamento das reservas'] },
    { quemFaz: 'Financeiro', objetivo: 'Adiantar o valor combinado antes da ida.' },
    { quemFaz: 'Viajante', objetivo: 'Registrar ocorrências relevantes durante a viagem.' },
    { quemFaz: 'Viajante + Financeiro', objetivo: 'Fechar as contas com comprovantes e apurar o saldo.', conexoes: ['Ligue a Reembolso de Despesas quando o viajante tiver a receber'] },
    { quemFaz: 'Gestor', objetivo: 'Registrar o motivo da recusa.' },
    { quemFaz: 'Financeiro', objetivo: 'Encerrar a viagem com tudo conciliado.' },
  ],
};

export const TEMPLATES_JURIDICO: DefaultTemplate[] = [contratosJuridico, processosJuridicos];
export const TEMPLATES_OPERACIONAL: DefaultTemplate[] = [gestaoProjetos];
export const TEMPLATES_ATENDIMENTO: DefaultTemplate[] = [atendimento];
export const TEMPLATES_VIAGENS: DefaultTemplate[] = [viagens];
